var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteComma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.332,
    height: 57.096,
    viewBox: "0 0 77.332 57.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ed193a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.332 57.096) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,52.073H18.756c-.321,13.67-4.2,15.221-9.067,15.664l-1.878.233V83l2.165-.116c6.359-.358,13.389-1.5,18.079-7.294,4.111-5.076,5.924-13.368,5.924-26.1V25.9H0Z",
    transform: "translate(0 -25.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M111,25.9V52.073h18.506c-.321,13.67-4.072,15.221-8.942,15.664l-1.753.233V83l2.04-.116c6.359-.358,13.452-1.5,18.142-7.294,4.111-5.076,5.986-13.368,5.986-26.1V25.9Z",
    transform: "translate(-67.647 -25.905)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteComma);
export default __webpack_public_path__ + "static/media/quote-comma.6707629cf1d498781a2fe3eae6e61d39.svg";
export { ForwardRef as ReactComponent };